"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { authUtils } from "@/lib/auth";

/**
 * When the app loads with ?impToken=... (e.g. from "Login as Customer" in a new tab),
 * stores the token in sessionStorage and removes it from the URL so the same dashboard
 * routes work and the tab uses the customer's role for API calls and UI.
 */
export default function ImpTokenHandler() {
  const pathname = usePathname();

  useEffect(() => {
    if (typeof window === "undefined") return;
    const params = new URLSearchParams(window.location.search);
    const impToken = params.get("impToken");
    if (!impToken) return;

    authUtils.setImpersonationToken(impToken);
    const url = pathname + (window.location.hash || "");
    window.history.replaceState({}, "", url);
  }, [pathname]);

  return null;
}
